import React, { Component } from 'react'

class SandwichName extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bread: this.props.bread,
      peanutButter: this.props.peanutButter,
      garnishes: this.props.garnishes
    };
  }

  reduceGarnishes(prevGarnish, currentGarnish, index, array) {
    if (index < array.length - 1) {
      return prevGarnish + currentGarnish + " + ";  
    }
    else {
      return prevGarnish + currentGarnish;
    }
  }

  render() {
    var garnishes = this.state.garnishes.reduce(this.reduceGarnishes, '');

    return (
      <div>{this.state.bread} + {this.state.peanutButter} Peanut Butter +<br/> {garnishes}</div>
    );
  }
}

export default SandwichName



// WEBPACK FOOTER //
// ./src/scripts/components/SandwichName.js